<div class="loader-container">
    <div class="linear-background">
        <div class="inter-draw"></div>
        <div class="inter-crop"></div>
        <div class="inter-right--top"></div>
        <div class="inter-right--bottom"></div>
    </div>
</div>